import React from "react"
import { Redirect } from "react-router-dom"

// Pages Component
import Chat from "../pages/Chat/Chat"

// File Manager
// import FileManager from "../pages/FileManager/index"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

// //Tasks
// import TasksList from "../pages/Tasks/tasks-list"
// import TasksKanban from "../pages/Tasks/tasks-kanban"
// import TasksCreate from "../pages/Tasks/tasks-create"

// //Projects
// import ProjectsGrid from "../pages/Projects/projects-grid"
// import ProjectsList from "../pages/Projects/projects-list"
// import ProjectsOverview from "../pages/Projects/ProjectOverview/projects-overview"
// import ProjectsCreate from "../pages/Projects/projects-create"

// //Ecommerce Pages
// import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index"
// import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail"
// import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index"
// import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index"
// import EcommerceCart from "../pages/Ecommerce/EcommerceCart"
// import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout"
// import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index"
// import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct"

//Email
// import EmailInbox from "../pages/Email/email-inbox"
// import EmailRead from "../pages/Email/email-read"
// import EmailBasicTemplte from "../pages/Email/email-basic-templte"
// import EmailAlertTemplte from "../pages/Email/email-template-alert"
// import EmailTemplateBilling from "../pages/Email/email-template-billing"

//Invoices
// import InvoicesList from "../pages/Invoices/invoices-list"
// import InvoiceDetail from "../pages/Invoices/invoices-detail"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import HelpPage from "pages/Authentication/Help"

//  // Inner Authentication
// import Login1 from "../pages/AuthenticationInner/Login"
// import Login2 from "../pages/AuthenticationInner/Login2"
// import Register1 from "../pages/AuthenticationInner/Register"
// import Register2 from "../pages/AuthenticationInner/Register2"
// import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
// import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2"
// import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword"
// import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2"
// import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"
// import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2"
// import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail"
// import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2"
// import EmailVerification from "../pages/AuthenticationInner/auth-email-verification"
// import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2"
// import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification"
// import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2"

// // Dashboard
// import Dashboard from "../pages/Dashboard/index";
// import DashboardSaas from "../pages/Dashboard-saas/index";
// import DashboardCrypto from "../pages/Dashboard-crypto/index";
import Blog from "../pages/Dashboard-Blog/index"

//Crypto
// import CryptoWallet from "../pages/Crypto/CryptoWallet/crypto-wallet"
// import CryptoBuySell from "../pages/Crypto/crypto-buy-sell"
// import CryptoExchange from "../pages/Crypto/crypto-exchange"
// import CryptoLending from "../pages/Crypto/crypto-lending"
// import CryptoOrders from "../pages/Crypto/CryptoOrders/crypto-orders"
// import CryptoKYCApplication from "../pages/Crypto/crypto-kyc-application"
// import CryptoIcoLanding from "../pages/Crypto/CryptoIcoLanding/index"

// Charts
// import ChartApex from "../pages/Charts/Apexcharts"
// import ChartistChart from "../pages/Charts/ChartistChart"
// import ChartjsChart from "../pages/Charts/ChartjsChart"
// import EChart from "../pages/Charts/EChart"
// import SparklineChart from "../pages/Charts/SparklineChart"
// import ChartsKnob from "../pages/Charts/charts-knob"
// import ReCharts from "../pages/Charts/ReCharts"

// Maps
// import MapsGoogle from "../pages/Maps/MapsGoogle"
// import MapsVector from "../pages/Maps/MapsVector"
// import MapsLeaflet from "../pages/Maps/MapsLeaflet"

//Icons
// import IconBoxicons from "../pages/Icons/IconBoxicons"
// import IconDripicons from "../pages/Icons/IconDripicons"
// import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
// import IconFontawesome from "../pages/Icons/IconFontawesome"

//Tables
// import BasicTables from "../pages/Tables/BasicTables"
// import DatatableTables from "../pages/Tables/DatatableTables"
// import ResponsiveTables from "../pages/Tables/ResponsiveTables"
// import EditableTables from "../pages/Tables/EditableTables"
// import DragDropTables from "../pages/Tables/DragDropTables"

//Blog
// import BlogList from "../pages/Blog/BlogList/index"
// import BlogGrid from "../pages/Blog/BlogGrid/index"
// import BlogDetails from "../pages/Blog/BlogDetails"

// Forms
// import FormElements from "../pages/Forms/FormElements"
// import FormLayouts from "../pages/Forms/FormLayouts"
// import FormAdvanced from "../pages/Forms/FormAdvanced"
// import FormEditors from "../pages/Forms/FormEditors"
// import FormValidations from "../pages/Forms/FormValidations"
// import FormMask from "../pages/Forms/FormMask"
// import FormRepeater from "../pages/Forms/FormRepeater"
// import FormUpload from "../pages/Forms/FormUpload"
// import FormWizard from "../pages/Forms/FormWizard"
// import FormXeditable from "../pages/Forms/FormXeditable"
// import DualListbox from "../pages/Tables/DualListbox"

//Ui
import UiAlert from "../pages/Ui/UiAlert"
import UiButtons from "../pages/Ui/UiButtons"
import UiCards from "../pages/Ui/UiCards"
import UiCarousel from "../pages/Ui/UiCarousel"
import UiColors from "../pages/Ui/UiColors"
import UiDropdown from "../pages/Ui/UiDropdown"
import UiGeneral from "../pages/Ui/UiGeneral"
import UiGrid from "../pages/Ui/UiGrid"
import UiImages from "../pages/Ui/UiImages"
import UiLightbox from "../pages/Ui/UiLightbox"
import UiModal from "../pages/Ui/UiModal"
import UiProgressbar from "../pages/Ui/UiProgressbar"
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
import UiTypography from "../pages/Ui/UiTypography"
import UiVideo from "../pages/Ui/UiVideo"
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
import UiRating from "../pages/Ui/UiRating"
import UiRangeSlider from "../pages/Ui/UiRangeSlider"
import UiNotifications from "../pages/Ui/ui-notifications"
import UiOffCanvas from "pages/Ui/UiOffCanvas"
import UiBreadcrumb from "../pages/Ui/UiBreadcrumb"
import UiPlaceholders from "../pages/Ui/UiPlaceholders"
import UiToasts from "../pages/Ui/UiToast"

//Pages
// import PagesStarter from "../pages/Utility/pages-starter"
// import PagesMaintenance from "../pages/Utility/pages-maintenance"
// import PagesComingsoon from "../pages/Utility/pages-comingsoon"
// import PagesTimeline from "../pages/Utility/pages-timeline"
// import PagesFaqs from "../pages/Utility/pages-faqs"
// import PagesPricing from "../pages/Utility/pages-pricing"
// import Pages404 from "../pages/Utility/pages-404"
// import Pages500 from "../pages/Utility/pages-500"

//Contacts
// import ContactsGrid from "../pages/Contacts/contacts-grid"
// import ContactsList from "../pages/Contacts/ContactList/contacts-list"
// import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile"

// Verify Screen
import VerifyScreen from "../pages/Reports/VerifyScreens"
import VerifyScreenTeams from "../pages/Reports/VerifyMyTeams"
// Manage Settings
import ManageSetting from "../pages/Admin/ManageSettings"
import AccessGroupSetting from "../pages/Admin/ManageAcessGroup"
import EmailConfirmation from "pages/Authentication/EmailConfirmation"
import ManageCompany from "pages/Admin/ManageCompany"
import ManageEmployee from "pages/Admin/ManageEmployee"
import confirmEmail from "pages/Authentication/activeUser"
import CompanyResetPwd from "pages/Authentication/CompanyResetPwd"
import TrackProfile from "pages/Admin/ManageTrackProfile"
import ManageUser from "pages/Admin/ManageUser"
import CreateTeam from "pages/Admin/MangeTeam/CreateTeam"
import ManageTeam from "pages/Admin/MangeTeam/ManageTeams"
import ManageClient from "pages/Admin/ManageClient"
import RouteControl from "./authLayout"
import UserauthLayout from "./UserauthLayout"
import Verifyworkhours from "../pages/Reports/verifyworkreport"
import Organizations from "pages/Admin/CompanyDetails/organization"
import ApplicationSetups from "pages/Admin/CompanyDetails/appUploadscreen"
import ClientViewsScreens from "pages/Reports/verifyworkreport/ClientViewsScreen"
import UserTimeLogScreen from "pages/Reports/TimeLog"
import UserActivityLogScreen from "pages/Reports/ActivityLog"
import HoursReportV1 from  "pages/Admin/HoursReport"
import HoursReportV0 from  "pages/Admin/HoursReportV0"
import Webhook from  "pages/Admin/WebHooks"
import WorkFromHome from  "pages/Admin/WorkFromHome"
import ScrutinyNotes from  "pages/Admin/ScrutinyNote"
import CalculateIncentive from "pages/Admin/CalculateIncentive";
import AttendanceDetails from "pages/Admin/AttendanceDetails"
import ManageAIInvoice from "pages/Admin/ManageAIInvoice"
import AIUsageReport from "pages/Admin/AIUsageReport"
import AIUsageDashboard from "pages/Admin/AIUsageDashboard"
import ReportSubmittedTime from "pages/Admin/ReportSubmittedTime"
import WorkspaceAudit from "pages/Admin/WorkspaceAudit"
import WorkspaceAuditExecutive from "pages/Admin/WorkspaceAuditExecutive"
import ErpClients from "pages/Admin/ErpClients"
import ErpClientDetail from "pages/Admin/ErpClients/ErpClientDetail"
import CrmOrganizations from "pages/Admin/CrmOrganizations"
import CrmOrganizationDetail from "pages/Admin/CrmOrganizations/CrmOrganizationDetail"

const ManageClients = () => {
  return (
    <RouteControl>
      <ManageClient />
    </RouteControl>
  )
}
const ErpClientsPage = () => {
  return (
    <RouteControl>
      <ErpClients />
    </RouteControl>
  )
}
const ErpClientDetailPage = () => {
  return (
    <RouteControl>
      <ErpClientDetail />
    </RouteControl>
  )
}
const CrmOrganizationsPage = () => {
  return (
    <RouteControl>
      <CrmOrganizations />
    </RouteControl>
  )
}
const CrmOrganizationDetailPage = () => {
  return (
    <RouteControl>
      <CrmOrganizationDetail />
    </RouteControl>
  )
}
const HoursReportsV1 = () => {
  return (
    <UserauthLayout>
      <HoursReportV1 />
    </UserauthLayout>
  )
}
const ReportSubmittedTimes = () => {
  return (
    <UserauthLayout>
      <ReportSubmittedTime />
    </UserauthLayout>
  )
}
const HoursReportsV0 = () => {
  return (
    <UserauthLayout>
      <HoursReportV0 />
    </UserauthLayout>
  )
}
const WebHooks = () => {
  return (
    <UserauthLayout>
      <Webhook />
    </UserauthLayout>
  )
}
const WorkspaceAudits = () => {
  return (
    <UserauthLayout>
      <WorkspaceAudit />
    </UserauthLayout>
  )
}
const WorkspaceAuditExecutives = () => {
  return (
    <UserauthLayout>
      <WorkspaceAuditExecutive />
    </UserauthLayout>
  )
}
const Workfromhomes = () => {
  return (
    <UserauthLayout>
      <WorkFromHome />
    </UserauthLayout>
  )
}
const ScrutinyNote =()=>{
  return (
    <UserauthLayout>
      <ScrutinyNotes />
    </UserauthLayout>
  )
}
const VerifyscreenTeams = () => {
  return (
    <UserauthLayout>
      <VerifyScreenTeams />
    </UserauthLayout>
  )
}

const ManageSettings = () => {
  return (
    <UserauthLayout>
      <ManageSetting />
    </UserauthLayout>
  )
}

const ManageCompanys = () => {
  return (
    <UserauthLayout>
      <ManageCompany />
    </UserauthLayout>
  )
}
const TrackProfiles = () => {
  return (
    <UserauthLayout>
      <TrackProfile />
    </UserauthLayout>
  )
}
const Organisations = () => {
  return (
    <UserauthLayout>
      <Organizations />
    </UserauthLayout>
  )
}
const ApplicationSetup = () => {
  return (
    <UserauthLayout>
      <ApplicationSetups />
    </UserauthLayout>
  )
}
const ManageUsers = () => {
  return (
    <UserauthLayout>
      <ManageUser />
    </UserauthLayout>
  )
}
const AccessGroupSettings = () => {
  return (
    <UserauthLayout>
      <AccessGroupSetting />
    </UserauthLayout>
  )
}
const ManageTeams = () => {
  return (
    <UserauthLayout>
      <ManageTeam />
    </UserauthLayout>
  )
}
// const ClientScreens = () => {
//   return (
//     <UserauthLayout>
//       <Clientviewscreen />
//     </UserauthLayout>
//   )
// }
const CreateTeams = () => {
  return (
    <UserauthLayout>
      <CreateTeam />
    </UserauthLayout>
  )
}

const CalculateIncentives = () => {
  return (
    <UserauthLayout>
      <CalculateIncentive />
    </UserauthLayout>
  )
}

const ManageAIInvoices = () => {
  return (
    <UserauthLayout>
      <ManageAIInvoice />
    </UserauthLayout>
  )
}

const AIUsageReports = () => {
  return (
    <UserauthLayout>
      <AIUsageReport />
    </UserauthLayout>
  )
}

const AIUsageDashboards = () => {
  return (
    <UserauthLayout>
      <AIUsageDashboard />
    </UserauthLayout>
  )
}

const CheckRoute =
  JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.useraccessgroupsettings || {}

const workReport =
  JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.accessgroupname === "CategoryUser" || {}

const authProtectedRoutes = [
  // {
  //   path: "/verifyscreenTeams",
  //   component: VerifyScreenTeams,
  //   hasUserAccess: CheckUserRoute,
  // },
  { path: "/client/viewscreens", component: ClientViewsScreens },
  {
    path: "/verifyscreenTeams",
    component: VerifyscreenTeams,
  },

  // {
  //   path: "/verifyworkhours",
  //   component: Verifyworkhours,
  // },
  {
    path: "/verifyscreen",
    component: VerifyScreen,
  },
  {
    path: "/usertimelog",
    component: UserTimeLogScreen,
  },
  {
    path: "/useractivitylog",
    component: UserActivityLogScreen,
    hasAccess: CheckRoute.accessAllTeam,
  },
  {
    path: "/managesettings",
    component: ManageSettings,
  },
  {
    path: "/managecompany",
    component: ManageCompanys,
  },
  {
    path: "/manageemployee",
    component: ManageEmployee,
  },
  {
    path: "/manageaccessgroup",
    component: AccessGroupSettings,
    hasAccess: CheckRoute.manageAccessGroup,
  },
  {
    path: "/trackprofile",
    component: TrackProfiles,
  },
  {
    path: "/organisation",
    component: Organisations,
  },
  {
    path: "/applicationsetup",
    component: ApplicationSetup,
  },
  {
    path: "/manageuser",
    component: ManageUsers,
  },
  {
    path: "/createteam",
    component: CreateTeams,
    hasAccess: CheckRoute.createTeam,
  },
  { path: "/manageteam", component: ManageTeams },

  {
    path: "/manageclient",
    component: ManageClients,
    hasAccess: CheckRoute.createMainCat || CheckRoute.createSubCat,
  },
  {
    path: "/erp-clients",
    component: ErpClientsPage,
    hasAccess: CheckRoute.createMainCat || CheckRoute.createSubCat,
  },
  {
    path: "/erp-client/:id",
    component: ErpClientDetailPage,
    hasAccess: CheckRoute.createMainCat || CheckRoute.createSubCat,
  },
  {
    path: "/crm-organizations",
    component: CrmOrganizationsPage,
    hasAccess: CheckRoute.createMainCat || CheckRoute.createSubCat,
  },
  {
    path: "/crm-organization/:id",
    component: CrmOrganizationDetailPage,
    hasAccess: CheckRoute.createMainCat || CheckRoute.createSubCat,
  },
  {
    path: "/hoursreport",
    component: HoursReportsV0,
  },
  {
    path: "/hoursreportv1",
    component: HoursReportsV1,
  },
  {
    path: "/reportsubmittedtime",
    component: ReportSubmittedTimes,
  },
  {
    path: "/webhooks",
    component: WebHooks,
  },
  {
    path: "/workspace-audit",
    component: WorkspaceAudits,
  },
  {
    path: "/workspace-audit-executive",
    component: WorkspaceAuditExecutives,
  },
  {
    path: "/workfromhome",
    component: Workfromhomes,
  },
  {
    path: "/scrutinynotes",
    component: ScrutinyNote,
  },

  {
    path: "/calculateincentives",
    component: CalculateIncentive,
  },
  {
    path: "/attendancedetails",
    component: AttendanceDetails,
  },
  {
    path: "/manageaiinvoice",
    component: ManageAIInvoices,
  },
  {
    path: "/aiusagereport",
    component: AIUsageReports,
  },
  {
    path: "/aiusagedashboard",
    component: AIUsageDashboards,
  },
  { path: "/blog", component: Blog },

  //Crypto
  // { path: "/crypto-wallet", component: CryptoWallet },
  // { path: "/crypto-buy-sell", component: CryptoBuySell },
  // { path: "/crypto-exchange", component: CryptoExchange },
  // { path: "/crypto-lending", component: CryptoLending },
  // { path: "/crypto-orders", component: CryptoOrders },
  // { path: "/crypto-kyc-application", component: CryptoKYCApplication },

  //chat
  { path: "/chat", component: Chat },

  //File Manager
  // { path: "/apps-filemanager", component: FileManager },

  // //calendar
  { path: "/calendar", component: Calendar },

  // //profile
  { path: "/profile", component: UserProfile },


  //Ecommerce
  // { path: "/ecommerce-product-detail/:id", component: EcommerceProductDetail },
  // { path: "/ecommerce-products", component: EcommerceProducts },
  // { path: "/ecommerce-orders", component: EcommerceOrders },
  // { path: "/ecommerce-customers", component: EcommerceCustomers },
  // { path: "/ecommerce-cart", component: EcommerceCart },
  // { path: "/ecommerce-checkout", component: EcommerceCheckout },
  // { path: "/ecommerce-shops", component: EcommerceShops },
  // { path: "/ecommerce-add-product", component: EcommerceAddProduct },

  //Email
  // { path: "/email-inbox", component: EmailInbox },
  // { path: "/email-read", component: EmailRead },
  // { path: "/email-template-basic", component: EmailBasicTemplte },
  // { path: "/email-template-alert", component: EmailAlertTemplte },
  // { path: "/email-template-billing", component: EmailTemplateBilling },

  //Invoices
  // { path: "/invoices-list", component: InvoicesList },
  // { path: "/invoices-detail/:id?", component: InvoiceDetail },

  // Tasks
  // { path: "/tasks-list", component: TasksList },
  // { path: "/tasks-kanban", component: TasksKanban },
  // { path: "/tasks-create", component: TasksCreate },

  //Projects
  // { path: "/projects-grid", component: ProjectsGrid },
  // { path: "/projects-list", component: ProjectsList },
  // { path: "/projects-overview", component: ProjectsOverview },
  // { path: "/projects-overview/:id", component: ProjectsOverview },
  // { path: "/projects-create", component: ProjectsCreate },

  //Blog
  // { path: "/blog-list", component: BlogList },
  // { path: "/blog-grid", component: BlogGrid },
  // { path: "/blog-details", component: BlogDetails },

  // Contacts
  // { path: "/contacts-grid", component: ContactsGrid },
  // { path: "/contacts-list", component: ContactsList },
  // { path: "/contacts-profile", component: ContactsProfile },

  //Charts
  // { path: "/apex-charts", component: ChartApex },
  // { path: "/chartist-charts", component: ChartistChart },
  // { path: "/chartjs-charts", component: ChartjsChart },
  // { path: "/e-charts", component: EChart },
  // { path: "/sparkline-charts", component: SparklineChart },
  // { path: "/charts-knob", component: ChartsKnob },
  // { path: "/re-charts", component: ReCharts },

  // Icons
  // { path: "/icons-boxicons", component: IconBoxicons },
  // { path: "/icons-dripicons", component: IconDripicons },
  // { path: "/icons-materialdesign", component: IconMaterialdesign },
  // { path: "/icons-fontawesome", component: IconFontawesome },

  // Tables
  // { path: "/tables-basic", component: BasicTables },
  // { path: "/tables-datatable", component: DatatableTables },
  // { path: "/tables-responsive", component: ResponsiveTables },
  // { path: "/tables-editable", component: EditableTables },
  // { path: "/tables-dragndrop", component: DragDropTables },

  // Maps
  // { path: "/maps-google", component: MapsGoogle },
  // { path: "/maps-vector", component: MapsVector },
  // { path: "/maps-leaflet", component: MapsLeaflet },

  // Forms
  // { path: "/form-elements", component: FormElements },
  // { path: "/form-layouts", component: FormLayouts },
  // { path: "/form-advanced", component: FormAdvanced },
  // { path: "/form-editors", component: FormEditors },
  // { path: "/form-mask", component: FormMask },
  // { path: "/form-repeater", component: FormRepeater },
  // { path: "/form-uploads", component: FormUpload },
  // { path: "/form-wizard", component: FormWizard },
  // { path: "/form-validation", component: FormValidations },
  // { path: "/form-xeditable", component: FormXeditable },
  // { path: "/dual-listbox", component: DualListbox },

  // Ui
  { path: "/ui-alerts", component: UiAlert },
  { path: "/ui-buttons", component: UiButtons },
  { path: "/ui-cards", component: UiCards },
  { path: "/ui-carousel", component: UiCarousel },
  { path: "/ui-colors", component: UiColors },
  { path: "/ui-dropdowns", component: UiDropdown },
  { path: "/ui-general", component: UiGeneral },
  { path: "/ui-grid", component: UiGrid },
  { path: "/ui-images", component: UiImages },
  { path: "/ui-lightbox", component: UiLightbox },
  { path: "/ui-modals", component: UiModal },
  { path: "/ui-progressbars", component: UiProgressbar },
  { path: "/ui-tabs-accordions", component: UiTabsAccordions },
  { path: "/ui-typography", component: UiTypography },
  { path: "/ui-video", component: UiVideo },
  { path: "/ui-session-timeout", component: UiSessionTimeout },
  { path: "/ui-rating", component: UiRating },
  { path: "/ui-rangeslider", component: UiRangeSlider },
  { path: "/ui-notifications", component: UiNotifications },
  { path: "/ui-offcanvas", component: UiOffCanvas },
  { path: "/ui-breadcrumb", component: UiBreadcrumb },
  { path: "/ui-placeholders", component: UiPlaceholders },
  { path: "/ui-toasts", component: UiToasts },
  { path: "/help" , component: HelpPage },


  //Utility
  // { path: "/pages-starter", component: PagesStarter },
  // { path: "/pages-timeline", component: PagesTimeline },
  // { path: "/pages-faqs", component: PagesFaqs },
  // { path: "/pages-pricing", component: PagesPricing },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/verifyscreen" /> },
]
const authProtectedRoutesCategory = [
  {
    path: "/client/viewhours",
    component: Verifyworkhours,
    hasAccess: workReport,
  },
  { path: "/profile", component: UserProfile },
  { path: "/client/viewscreens", component: ClientViewsScreens },
]

const reportingenabled = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.reportingenabled

if(reportingenabled){
  authProtectedRoutesCategory.push(
    {
      path: "/verifyscreenTeams",
      component: VerifyscreenTeams,
    }
  )
}

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/help" , component: HelpPage},

  // { path: "/pages-maintenance", component: PagesMaintenance },
  // { path: "/pages-comingsoon", component: PagesComingsoon },
  // { path: "/pages-404", component: Pages404 },
  // { path: "/pages-500", component: Pages500 },
  // { path: "/crypto-ico-landing", component: CryptoIcoLanding },

  // Authentication Inner
  // { path: "/pages-login", component: Login1 },
  // { path: "/pages-login-2", component: Login2 },
  // { path: "/pages-register", component: Register1 },
  // { path: "/pages-register-2", component: Register2 },
  // { path: "/page-recoverpw", component: Recoverpw },
  // { path: "/page-recoverpw-2", component: Recoverpw2 },
  // { path: "/pages-forgot-pwd", component: ForgetPwd1 },
  // { path: "/auth-recoverpw-2", component: ForgetPwd2 },
  // { path: "/auth-lock-screen", component: LockScreen },
  // { path: "/auth-lock-screen-2", component: LockScreen2 },
  // { path: "/emailconfirmation", component: EmailConfirmation },
  // { path: "/page-confirm-mail", component: ConfirmMail },
  // { path: "/page-confirm-mail-2", component: ConfirmMail2 },
  // { path: "/auth-email-verification", component: EmailVerification },
  // { path: "/auth-email-verification-2", component: EmailVerification2 },
  // { path: "/auth-two-step-verification", component: TwostepVerification },
  // { path: "/auth-two-step-verification-2", component: TwostepVerification2 },

  { path: "/verifiy-account", component: confirmEmail },
  { path: "/reset-password", component: EmailConfirmation },
  { path: "/verifiy-companyaccount", component: EmailConfirmation },
  { path: "/activate-company", component: CompanyResetPwd },
]

export { authProtectedRoutes, publicRoutes, authProtectedRoutesCategory }
